import { Obj } from "./types"

export const shortenUrl = async (url: string) => {
  const res = await fetch(`https://url.ojapi.nl?url=${url}`).then(x => x.text()) //https://smurl.orange-juice.nl
  return res
}

export const uploadFile = async (base64: string) => {
  const res = await fetch(`https://arm-fileapi.orange-juice.nl/file/upload`, { method: "POST", body: base64 }).then(x => x.json())
  const url = `https://arm-fileapi.orange-juice.nl/file/load?id=${res}`
  // return url
  return shortenUrl(url)
}

const fetchJSON = (url: string, options: RequestInit = {}) => {
  const headers = new Headers()
  headers.append("Content-Type", "application/json")
  return fetch(url, { headers, ...options }).then(x => x.json())
}

export const createCartLine = async ({ id, quantity, properties }: { id: number, quantity: number, properties: Obj<string> }) =>
  fetchJSON("/cart/add.js", { method: "POST", body: JSON.stringify({ id, quantity, properties }) })

export const updateCartLine = async (cartLineKey: string, { quantity, properties }: { id?: number, quantity?: number, properties?: Obj<string> }) =>
  fetchJSON("/cart/change.js", { method: "POST", body: JSON.stringify({ id: cartLineKey, quantity, properties }) })

export const getCart = async () =>
  fetchJSON("/cart.js", { method: "GET" })

export const convertEPS = async (file: File, size: number) => {
  const formData = new FormData()
  formData.append("eps", file)
  const res = await fetch(`https://arm-imageconversion.orange-juice.nl/eps/command/?width=${size}&height=${size}`, { method: "POST", body: formData })
    .then(x => x.text())
  return res
}